// extracted by mini-css-extract-plugin
export default {"img_style":"CarouselImages_img_style__a3+IW","no_image":"CarouselImages_no_image__8FzJA"};